import React, { useCallback } from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
import { Link, useLocation } from 'react-router-dom';
import useCloseSearch from '../../../global-state/isSearchOpen/useCloseSearch';

/**
 * See full results button with dynamic hit count
 */
const SeeFullResultsButton = connectStateResults(({ searchResults }) => {
  const closeSearch = useCloseSearch();
  const location = useLocation();

  const searchUrl = searchResults?.query
    ? `/search/?category=products_jb4&q=${encodeURIComponent(
        searchResults.query
      )}&filter=*`
    : '';

  const handleClick = useCallback(() => {
    closeSearch();

    // If we're already on the search page, refresh to show new results
    if (location.pathname === '/search/' && searchUrl) {
      window.location.href = searchUrl;
    }
  }, [closeSearch, location.pathname, searchUrl]);

  if (!searchResults || !searchResults.query) {
    return null;
  }

  return (
    <Link
      to={searchUrl}
      className="[text-decoration:none]"
      aria-label={`See all ${searchResults.nbHits} results for ${searchResults.query}`}
      onClick={handleClick}
    >
      <div className="bg-gray text-white text-base font-bold px-6 py-3 font-semibold text-sm hover:bg-gray-800 transition-colors">
        See full results ({searchResults.nbHits})
      </div>
    </Link>
  );
});

export default SeeFullResultsButton;
